import { Box, Typography } from "@mui/material";
import { FilterButton } from "../../../utils/FilterButton";
import { DateFilterDropdown } from "../../../utils/DateFilterDropdown";
import { AppliedFilterChips } from "../../../utils/AppliedFilterChips";
import { FilterObj, OverallProgressFilterObj } from "../../../../../types";
import { useContext } from "react";
import { InsightsProgressFilterContext } from "../../../../../context/InsightsProgressFilterContext";
import { InsightsFilterCtx } from "../../../../../interfaces";
import { HandleDataLayer } from "../../../../../Helpers";
import { ReportDownloadButton } from "../../../utils/ReportDownloadButton";
import { DownloadableReport } from "../../../../../hooks/useXLSXGenerator";

interface HeaderProps {
  title: string;
  downloadableReport: DownloadableReport;
  onDateFilterChange?: (filterObj: FilterObj) => void;
}

export const Header = (props: HeaderProps) => {
  const { title, onDateFilterChange, downloadableReport } = props;
  const insightsProgressFilterCtx = useContext(
    InsightsProgressFilterContext
  ) as InsightsFilterCtx;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Typography variant="h3">{title}</Typography>
        <Box
          sx={{
            marginLeft: "auto",
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            alignItems: "center",
          }}>
          <ReportDownloadButton report={downloadableReport} />

          <FilterButton
            handleOpen={() => {
              if (insightsProgressFilterCtx.filterModalOpen) {
                HandleDataLayer(
                  "modal",
                  "close",
                  "click",
                  "main content",
                  title,
                  "filter",
                  "onclick"
                );
              } else {
                HandleDataLayer(
                  "modal",
                  "open",
                  "click",
                  "main content",
                  title,
                  "filter",
                  "onclick"
                );
              }
              insightsProgressFilterCtx.setFilterModalOpen(true);
            }}
            filterCount={insightsProgressFilterCtx.filters.length}
          />
          <DateFilterDropdown
            section={title}
            selectedFilter={insightsProgressFilterCtx.selectedDateFilter}
            onFilterChange={(filterObj) => {
              insightsProgressFilterCtx.setSelectedDateFilter(filterObj);
              if (onDateFilterChange) {
                onDateFilterChange(filterObj);
              }
            }}
          />
        </Box>
      </Box>
      {insightsProgressFilterCtx.filters.length > 0 && (
        <AppliedFilterChips
          filters={insightsProgressFilterCtx.filters}
          onFilterChange={(filter: OverallProgressFilterObj) => {
            insightsProgressFilterCtx.setFilters(
              insightsProgressFilterCtx.filters.filter((f) => f.id !== filter.id)
            );
          }}
          onFiltersClear={() => {
            insightsProgressFilterCtx.setFilters([]);
          }}
        />
      )}
    </Box>
  );
};
